import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { CldrIntlService } from '@progress/kendo-angular-intl';

@Injectable()
export class MyIntlService extends CldrIntlService {
  constructor(@Inject(LOCALE_ID) localeId: string) {
    super(localeId);
  }

  // 0 = Sunday, 1 = Monday, 2 = Tuesday, etc.
  public override firstDay(): number {
    return 1; 
  }
}